import { LoaderFunctionArgs } from 'react-router-dom'
import { getWarranty } from '../../action'

export const videoEditorPageLoader = async (args: LoaderFunctionArgs) => {
    const warrantyId = Number(args.params.id);
    await getWarranty(warrantyId);

    return {}
}
